import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { getWaitForReviewer } from '../../redux/actions/dashboard'
import './styles.less'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitForReviewer({ config, onSettingChange = () => {} }) {
  // const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    try {
      const response = await getWaitForReviewer(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('getWaitForReviewer => ', response)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const onMutiSubmit = (selectList) => {
    // console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)

    return history.push({
      pathname: `${pathname.proposal.review.projectList}/multi-reveiw`,
      state: { selectId: idList },
    })
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            //multi={{ enable: true, buttonText: schema?.mutiButtonText }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
              // icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            // onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รอกลั่นกรองทางวิชาการ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectEditVerText: 'ภายในวันที่',
  buttonText: 'กลั่นกรอง',
  totalSize: 1,
  values: [
    {
      id: 'XXX',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXX',
        statusName: 'XXX',
      },
      projectBudget: '0.00',
      projectType: {
        value: 'โครงการ',
        label: '1',
      },
    },
  ],
}
